import React from 'react';
import {StyleProp, StyleSheet, View, ViewStyle} from 'react-native';

import {useSpinner} from '../../../contexts/spinner';
import {UseGoogleLoginOptions} from '../../../lib/auth/google/useGoogleLoginOptions';
import {useAppleLogin, useGoogleLogin} from '../../../lib/hooks/useLogin';
import {AppleSignIn} from './AppleSignIn';
import {GoogleSignIn} from './GoogleSignIn';

export interface SocialAuthProps {
  screen: UseGoogleLoginOptions['state'];
  disabled?: boolean;
  style?: StyleProp<ViewStyle>;
}

export const SocialAuth: React.FC<SocialAuthProps> = ({
  disabled,
  screen = 'login',
  style,
}) => {
  const [google, loginWithGoogle] = useGoogleLogin();
  const [apple, loginWithApple] = useAppleLogin();

  const isLoading = google.loading || apple.loading;

  disabled = disabled || isLoading;

  useSpinner({isVisible: isLoading});

  return (
    <View style={[styles.socialContainer, style]}>
      <View style={styles.buttonWrapper}>
        <GoogleSignIn {...{screen, disabled}} onSubmit={loginWithGoogle} />
      </View>

      <View style={styles.buttonWrapper}>
        <AppleSignIn {...{screen, disabled}} onSubmit={loginWithApple} />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  socialContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    width: '100%',
  },
  buttonWrapper: {
    marginHorizontal: 12,
  },
});
